var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "table-div-id": _vm.tableDivId,
            "show-filter": false,
            data: _vm.fetchData,
            "table-class": "table",
          },
        },
        [
          _vm.userType == "funder"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.financing_request_date"),
                  "sort-as": "prepayment_date",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                row.pre_payment_request.formattedPrePaymentDate
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2473093795
                ),
              })
            : _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.date"),
                  "sort-as": "invoice_date",
                  show: "formattedInvoiceDate",
                },
              }),
          _vm._v(" "),
          _vm.userType == "funder"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.promised_payment_date"),
                  "sort-as": "promised_date",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                row.pre_payment_request
                                  .formattedPromisedPaymentDate
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4225585759
                ),
              })
            : _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.due_date"),
                  "sort-as": "due_date",
                  show: "formattedDueDate",
                },
              }),
          _vm._v(" "),
          _vm.userType === "super_admin" ||
          _vm.userType === "supplier" ||
          _vm.userType === "funder"
            ? _c("table-column", {
                attrs: { label: _vm.$t("invoices.customer"), width: "20%" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          row.buyer_stakeholder
                            ? _c("p", [
                                _vm.userType == "supplier" &&
                                row.customer.parent_account_id &&
                                row.buyer_stakeholder.details.company &&
                                row.buyer_stakeholder.details.company.name
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            row.buyer_stakeholder.details
                                              .company.name
                                          ) +
                                          "\n          "
                                      ),
                                    ])
                                  : _vm.userType == "supplier" &&
                                    row.customer.parent_account_id == null
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            row.buyer_stakeholder.details.user
                                              .name
                                          ) +
                                          "\n          "
                                      ),
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            row.buyer_stakeholder.details
                                              .company.name
                                          ) +
                                          "\n          "
                                      ),
                                    ]),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2439368310
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userType === "super_admin" ||
          _vm.userType === "anchor" ||
          _vm.userType === "funder"
            ? _c("table-column", {
                attrs: { label: _vm.$t("invoices.supplier") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          row.supplier_stakeholder
                            ? _c("p", [
                                row.supplier_stakeholder.details.company &&
                                row.supplier_stakeholder.details.company.name
                                  ? _c("span", [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            row.supplier_stakeholder.details
                                              .company.name
                                          ) +
                                          "\n          "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4122532740
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.userType != "super_admin"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("invoices.status"),
                  "sort-as": "status",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return row.overall_status
                          ? [
                              _c("span", [
                                _vm._v(" " + _vm._s(_vm.$t("invoices.status"))),
                              ]),
                              _vm._v(" "),
                              _vm.userType == "anchor" &&
                              row.overall_status == "SENT"
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "inv-status-" +
                                        row.overall_status.toLowerCase(),
                                    },
                                    [_vm._v(_vm._s(_vm.$t("general.received")))]
                                  )
                                : _vm.userType == "anchor" &&
                                  row.overall_status != "SENT"
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "inv-status-" +
                                        row.overall_status.toLowerCase(),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.overall_status != "PARTIALLY_PAID"
                                            ? row.overall_status
                                            : row.overall_status.replace(
                                                "_",
                                                " "
                                              )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm.userType != "anchor"
                                ? _c(
                                    "span",
                                    {
                                      class:
                                        "inv-status-" +
                                        row.overall_status.toLowerCase(),
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          row.overall_status != "PARTIALLY_PAID"
                                            ? row.overall_status
                                            : row.overall_status.replace(
                                                "_",
                                                " "
                                              )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : undefined
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.number"), show: "invoice_number" },
          }),
          _vm._v(" "),
          _vm.userType != "funder"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("deliveryNotes.delivery_note_number"),
                  show: "delivery_note.delivery_note_number",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("invoices.nominal_amount"),
              "sort-as": "total",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("invoices.total")))]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.nominal_amount,
                            row.customer.currency
                          )
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("general.cashflow_value"),
              "sort-as": "total",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("invoices.total")))]),
                    _vm._v(" "),
                    row.invoice_approved
                      ? _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$utils.formatMoney(
                                row.total,
                                row.customer.currency
                              )
                            ),
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: { label: _vm.$t("invoices.prePayment") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(" " + _vm._s(_vm.$t("invoices.prePayment"))),
                    ]),
                    _vm._v(" "),
                    row.request_level == "Pending" && row.funder_invoices.user
                      ? _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(row.request_level) +
                                "-" +
                                _vm._s(row.funder_invoices.user.name)
                            ),
                          ]
                        )
                      : _vm.userType == "anchor" &&
                        row.request_level == "Eligible"
                      ? _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [_vm._v("No Request")]
                        )
                      : _vm.userType == "anchor" &&
                        row.request_level == "Requested"
                      ? _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [_vm._v("Supplier Create Request")]
                        )
                      : _vm.userType == "anchor" &&
                        row.request_level == "Verified"
                      ? _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("general.Requested")))]
                        )
                      : row.request_level == "Financed"
                      ? _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [_vm._v(_vm._s(_vm.$t("general.financing_approved")))]
                        )
                      : _c(
                          "span",
                          {
                            class:
                              "inv-status-" + row.request_level.toLowerCase(),
                          },
                          [_vm._v(" " + _vm._s(row.request_level))]
                        ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.userType == "supplier"
        ? _c("div", [
            _vm.fetchData[0] && _vm.fetchData[0].non_fianance_invoice_info
              ? _c("div", { staticClass: "payment-card card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("payments.schedule_payment_date")) +
                            "\n            "
                        ),
                        _vm.fetchData[0] &&
                        _vm.fetchData[0].non_fianance_invoice_info
                          ? _c("span", [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.fetchData[0].non_fianance_invoice_info
                                      .formattedSchedulePaymentDate
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }